import React from "react";

// Mobile app header for quiz pages. `safe-area-top` pushes it below the
// device status bar / notch on Capacitor builds. `title` is optional — when
// omitted, the left back button and an optional `right` slot (e.g. the lives
// counter) are all that show, so the header doesn't repeat the quiz name that
// the page body already displays.
export default function QuizHeader({
  title,
  onBack,
  right,
}: {
  title?: string;
  onBack: () => void;
  right?: React.ReactNode;
}) {
  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-slate-200 safe-area-top">
      <div className="flex items-center gap-2 px-3 py-1.5">
        <button
          onClick={onBack}
          className="p-1.5 -ml-1.5 rounded-lg hover:bg-slate-100 transition-colors"
        >
          <svg className="w-5 h-5 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        {title ? (
          <h1 className="text-lg font-semibold text-slate-800 truncate flex-1">{title}</h1>
        ) : (
          <div className="flex-1" />
        )}
        {right}
      </div>
    </header>
  );
}
